import LegalPage from "../components/LegalPage";
import site from "../data/site";

function DataDeletion() {
  const sections = [
    {
      heading: "Data Eligible for Deletion",
      list: [
        "Name",
        "Email address",
        "Phone number",
        "Account information",
        "Messages and usage data",
      ],
    },
    {
      heading: "How to Request Data Deletion",
      body: `To request deletion of your data, please send an email to: ${site.email}. Use the subject line "User Data Deletion Request" and include your registered email or phone number, clearly stating your request for data deletion.`,
    },
    {
      heading: "Deletion Timeline",
      body: "All deletion requests are processed within 7 to 30 days. Once deleted, data cannot be recovered.",
    },
    {
      heading: "Legal Compliance",
      body: "We do not retain deleted personal data unless required by applicable law.",
    },
    {
      heading: "Contact Us",
      body: `If you need help with the deletion process, contact us at: ${site.email}`,
    },
  ];

  return (
    <LegalPage
      title="User Data"
      titleAccent="Deletion"
      lead="Instructions on how to request deletion of your personal data."
      sections={[
        {
          heading: "Introduction",
          body: "Odinno respects your privacy and gives you full control over your personal data. You may request deletion of your data at any time.",
        },
        ...sections,
      ]}
    />
  );
}

export default DataDeletion;
